import type { StaticFileIdFormat } from '../../../model/model.ts'

export const frMrgaGeneralTermsStaticFileId_v1_0_0 =
  'fr-mrga-general-terms-v1_0_0' as const satisfies StaticFileIdFormat<'fr-mrga'>

export const frMrgaIpidStaticFileId_v1_0_0 = 'fr-mrga-ipid-v1_0_0' as const satisfies StaticFileIdFormat<'fr-mrga'>

export const frMrgaLegalProtectionTermsStaticFileId_v1_0_0 =
  'fr-mrga-legal-protection-terms-v1_0_0' as const satisfies StaticFileIdFormat<'fr-mrga'>

export const frMrgaLegalProtectionIpidStaticFileId_v1_0_0 =
  'fr-mrga-legal-protection-ipid-v1_0_0' as const satisfies StaticFileIdFormat<'fr-mrga'>

export const frMrgaStaticFilesIds_v1_0_0 = [
  frMrgaGeneralTermsStaticFileId_v1_0_0,
  frMrgaIpidStaticFileId_v1_0_0,
  frMrgaLegalProtectionTermsStaticFileId_v1_0_0,
  frMrgaLegalProtectionIpidStaticFileId_v1_0_0,
] as const satisfies readonly StaticFileIdFormat<'fr-mrga'>[]
